module.exports = __webpack_public_path__ + "static/media/solos-splash.55438ea8.png";